/*****/ document.addEventListener("DOMContentLoaded", function () {
    function formatPrices() {
        document.querySelectorAll("#_rsi-cod-form-modal .money").forEach(function (el) {
            let priceText = el.innerText.replace(/[^\d]/g, ""); 
            if (priceText) {
                let formattedPrice = Number(priceText).toLocaleString("en-US").replace(/,/g, ".");
                el.innerText = formattedPrice.replace(/\./g, ",");
            }
        });
    }

    // Check if modal is open every second and format prices
    setInterval(function () {
        let modal = document.querySelector("#_rsi-cod-form-modal");
        if (modal && modal.style.display !== "none") {
            formatPrices();
        }
    }, 1000); // Runs every second
});



document.addEventListener('DOMContentLoaded', () => {
    const menu = document.getElementById('Details-menu-drawer-container');
    const button = document.querySelector('.sticky-buy-bar');
    
    if (menu && button) {
        // Store the original display value (defaults to computed style if not set)
        const originalDisplay = window.getComputedStyle(button).display;
        
        new MutationObserver((mutations) => {
            if (menu.classList.contains('menu-opening')) {
                // Hide the button if menu is opening
                button.style.display = 'none';
            } else {
                // Restore the original display value when menu closes
                button.style.display = 'flex';
            }
        }).observe(menu, { attributes: true, attributeFilter: ['class'] });
    }
});


/***

///Tidio Contact Us Button
document.addEventListener('DOMContentLoaded', function() {
  // First check if Tidio iframe exists
  const checkForTidio = setInterval(function() {
    const iframe = document.querySelector('#tidio-chat-iframe');
    const chatTrigger = document.getElementById('HeaderDrawer-contact-us');
    
    if (iframe) {
      clearInterval(checkForTidio); // Stop checking once found
      
      // Show the contact us button
      if (chatTrigger) {
        chatTrigger.style.display = 'block'; // or 'inline' or '' depending on your layout
        
        // Add click handler
        chatTrigger.addEventListener('click', function(e) {
          e.preventDefault();
          // Try Tidio's official method first
          if (typeof tidioChatApi !== 'undefined') {
            tidioChatApi.open();
          } 
          // Fallback to iframe click
          else {
            iframe.click();
          }
        });
      }
    } else {
      // Hide the contact us button if iframe not found
      if (chatTrigger) {
        chatTrigger.style.display = 'none';
      }
    }
  }, 500); // Check every 500ms

  // Optional: Add timeout to stop checking after a while
  setTimeout(function() {
    clearInterval(checkForTidio);
  }, 10000); // Stop checking after 10 seconds
});

****/




//Last week Sales


document.addEventListener('DOMContentLoaded', function() {
  // Get the product metafield value (assuming it's available in the global theme object)
  const productData = window.productData || {};
  const lastWeekSales = productData.metafields?.custom?.last_week_sales?.value;
  
  // Get the product form buttons element
  const productFormButtons = document.querySelector('.product-form__buttons');
  
  if (lastWeekSales && productFormButtons) {
    // Create the message element
    const salesMessage = document.createElement('div');
    salesMessage.className = 'last-week-sales-message';
    salesMessage.textContent = `Over ${lastWeekSales} sold in the last week`;
    salesMessage.style.marginBottom = '10px';
    salesMessage.style.textAlign = 'center';
    salesMessage.style.fontSize = '0.9em';
    salesMessage.style.color = '#555';
    
    // Insert the message before the product form buttons
    productFormButtons.parentNode.insertBefore(salesMessage, productFormButtons);
  }
});







// Block upcountry orders
(function () {
  var BLOCKED_REGIONS = [
    'lira',
    'mbarara',
    'arua',
    'soroti',
    'gulu',
    'kayunga',
    'luwero',
    'mityana',
    'mubende',
    'bugiri',
    'jinja',
    'bugweri',
    'busia',
    'iganga',
    'kapchwora',
    'kumi',
    'mbale',
    'pallisa',
    'adjumani',
    'koboko',
    'pakwach',
    'yumbe',
    'nebbi',
    'hoima',
    'bushenyi',
    'ibanda',
    'isingiro',
    'kisoro',
    'kabale',
    'kasese',
    'ntungamo',
    'sheema',
    'fortportal',
    'fort portal',
    'masindi',
    'masaka',
    'lwengo',
    'kyotera',
    'lyantonde',
    'gomba',
    'moyo',
    'kotido',
    'adjuman'
  ];

  // These towns can also appear as street names in Kampala.
  var SUFFIX_EXEMPT_REGIONS = [
    'jinja',
    'moyo'
  ];

  // If an exemptable town is followed by one of these,
  // treat it as a street name rather than the actual town.
  var ALLOWED_SUFFIXES = [
    'rd',
    'road',
    'close',
    'st',
    'street',
    'ave',
    'avenue',
    'lane',
    'way',
    'crescent',
    'drive',
    'park'
  ];

  // Detect and return the blocked town/region.
  function getBlockedRegion(value) {
    var lower = (value || '').toLowerCase();

    for (var i = 0; i < BLOCKED_REGIONS.length; i++) {
      var region = BLOCKED_REGIONS[i];
      var isExemptable =
        SUFFIX_EXEMPT_REGIONS.indexOf(region) !== -1;

      if (!isExemptable) {
        // Normal blocked region.
        if (
          new RegExp('\\b' + region + '\\b', 'i').test(lower)
        ) {
          return region;
        }
      } else {
        // Exemptable region such as Jinja or Moyo.
        var pattern = new RegExp(
          '\\b' + region + '\\b\\s*([a-z]*)',
          'gi'
        );

        var match;

        while ((match = pattern.exec(lower)) !== null) {
          var nextWord = (match[1] || '').trim();

          // If it isn't followed by an allowed street suffix,
          // then it's considered the actual blocked town.
          if (ALLOWED_SUFFIXES.indexOf(nextWord) === -1) {
            return region;
          }
        }
      }
    }

    return null;
  }

  // Capitalize the detected town/region.
  function capitalizeRegion(region) {
    return region
      .split(' ')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  function getWrapper(input) {
    return (
      input.closest('._rsi-modal-fields-item') ||
      input.parentElement
    );
  }

  function showAddressError(input) {
    clearAddressError(input);

    var blockedRegion = getBlockedRegion(input.value);

    if (!blockedRegion) return;

    var formattedRegion = capitalizeRegion(blockedRegion);

    var errorEl = document.createElement('div');
    errorEl.className = '_rsi-address-region-error';
    errorEl.style.color = '#d92d20';
    errorEl.style.fontSize = '0.85em';
    errorEl.style.marginTop = '4px';

    errorEl.textContent =
      "Payment on delivery isn't supported in " +
      formattedRegion +
      ". It will have to be prepaid to be sent over to you. Contact us if you want to proceed with it.";

    input.insertAdjacentElement('afterend', errorEl);

    input.style.border = '1px solid #d92d20';
  }

  function clearAddressError(input) {
    var wrapper = getWrapper(input);

    var existing = wrapper.querySelector(
      '._rsi-address-region-error'
    );

    if (existing) {
      existing.remove();
    }

    input.style.border = '';
  }

  // Capture phase so this runs BEFORE the Realsit app's
  // own submit handler.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;

      if (
        !form ||
        form.id !== '_rsi-cod-form-modal-form'
      ) {
        return;
      }

      var addressInput = form.querySelector(
        '#_rsi-field-address'
      );

      if (!addressInput) return;

      var blockedRegion = getBlockedRegion(
        addressInput.value
      );

      if (blockedRegion) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        showAddressError(addressInput);

        addressInput.focus();

        return false;
      } else {
        clearAddressError(addressInput);
      }
    },
    true
  );

  // Clear the error live as the customer edits the address.
  document.addEventListener('input', function (e) {
    if (
      e.target &&
      e.target.id === '_rsi-field-address'
    ) {
      if (!getBlockedRegion(e.target.value)) {
        clearAddressError(e.target);
      }
    }
  });
})();